import React from 'react';
import { generateClassNameByBehaviorSettings } from '../../../../utils/behaviorSettings';
import { DefaultPictureType, LinkWithLabel } from '../../../../types';
import DefaultPicture from '../../../01_atoms/DefaultPicture';
import Button from '../../../01_atoms/Button';
import { BehaviourSettingsType } from '../../../../utils/behaviorSettings/prop-types';

import s from './index.module.scss';

type Props = {
  heading: string;
  description: string;
  button: LinkWithLabel;
  image?: DefaultPictureType;
  behaviorSettings?: BehaviourSettingsType;
  uuid?: string;
};

const BBReadMore = ({
  heading,
  description,
  image,
  button,
  behaviorSettings = {},
  uuid = undefined,
}: Props) => {
  return (
    <div
      className={`bb ${s['bb-read-more']} ${generateClassNameByBehaviorSettings(behaviorSettings)}`}
      id={uuid}
      data-component={'read-more'}
    >
      <div className="container">
        <div
          className={`${image ? s['bb-read-more__with-image'] : s['bb-read-more__without-image']}`}
        >
          <div className={s['bb-read-more__wrapper']}>
            {image && (
              <div className={s['bb-read-more__image']}>
                <DefaultPicture loading="lazy" {...image} />
              </div>
            )}
            <div className={s['bb-read-more__content']}>
              <div className={s['bb-read-more__heading']}>{heading}</div>
              <div className={s['bb-read-more__content-body']}>
                <div className={s['bb-read-more__description']}>{description}</div>
                <div className={s['bb-read-more__button']}>
                  {button.nextLink && (
                    <Button
                      type={'secondary'}
                      size={'small'}
                      tag="a"
                      href={button.nextLink.url}
                      withArrow={true}
                    >
                      {button.label}
                    </Button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BBReadMore;
